import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { MaterialModule } from "../material.module";
import { PrimeModule } from "../prime.module";

import { RouterModule } from "@angular/router";
import { PrimaryButtonComponent } from "./primary-button/primary-button.component";
import { SliderComponent } from "./slider/slider.component";
import { TrackListComponent } from "./track-list/track-list.component";
import { TrackItemComponent } from "./track-list/track-item/track-item.component";
import { AudioPlayerComponent } from "./track-list/track-item/audio-player/audio-player.component";
import { ArangersListComponent } from "./arangers-list/arangers-list.component";
import { HttpAlertComponent } from "./http-alert/http-alert.component";
import { LoaderComponent } from "./loader/loader.component";
import { TranslateModule } from "@ngx-translate/core";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxImageZoomModule } from "ngx-image-zoom";

import { AuthorizationComponent } from "../authorization/login/authorization.component";
import { RegisterComponent } from "../authorization/register/register.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { HttpAlertService } from "../services/http-alert.service";
import { MessageService } from "primeng/api";
import { ForgotPasswordComponent } from "../authorization/forgot-password/forgot-password.component";
import { InvoiceDetailsListComponent } from "./invoice-details-list/invoice-details-list.component";
import { InvoiceDetailsComponent } from "./invoice-details-list/invoice-details/invoice-details.component";
import { UserDetailsFormComponent } from "./forms/user-details-form/user-details-form.component";
import { ArrangerDetailsFormComponent } from "./forms/arranger-details-form/arranger-details-form.component";
import { ArrangerCommissionFormComponent } from "./forms/arranger-commission-form/arranger-commission-form.component";
import { AddNotesComponent } from "./user/arranger/add-notes/add-notes.component";
import { NoteListComponent } from "./user/arranger/note-list/note-list.component";
import { CategoryComponent } from "./user/admin/category/category.component";
import { CartHandleComponent } from "./cart-handle/cart-handle.component";
import { CartComponent } from "./cart/cart.component";
import { CurrencyFormaterPipe } from "../pipes/currencyReduce.pipe";
import { PaymentTypeComponent } from "./cart/payment-type/payment-type.component";
import { ImageCropperComponent } from "./image-cropper/image-cropper.component";
import { NoteLevelComponent } from "./note-level/note-level.component";
import { SafeHtml } from "../pipes/safeUrl.pipe";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { PrepaidByCodeComponent } from "./prepaid-by-code/prepaid-by-code.component";
import { PrepaidTotalComponent } from "../shared/prepaid-total/prepaid-total.component";
import { DndModule } from "ngx-drag-drop";
import { OrdersManagementComponent } from "./user/admin/orders-management/orders-management.component";
import { ContractFormComponent } from "./forms/contract-form/contract-form.component";
import { ContractsComponent } from "./contracts/contracts.component";
import { OrderTotalPipe } from "../pipes/orderTotal.pipe";
import { ZaiksComponent } from "./zaiksReport/zaiks/zaiks.component";
import { ContractAttachmentsComponent } from "./contracts/contract-attachments/contract-attachments.component";
import { RateNoteComponent } from "./rate-note/rate-note.component";
import { ProfitsComponent } from "./user/arranger/profits/profits.component";
import { SuccessComponent } from "./user/arranger/add-notes/success/success.component";
import { PrepaidManagementComponent } from "./prepaid-management/prepaid-management.component";
import { CookiesComponent } from "./cookies/cookies.component";
import { ArrangerContractDateFormComponent } from "./forms/arranger-contract-date-form/arranger-contract-date-form.component";
import { InvoiceListComponent } from "./invoice-list/invoice-list.component";
import { SongSuggestionComponent } from "./song-suggestion/song-suggestion.component";
import { RecaptchaModule } from "ng-recaptcha";
import { NewsletterOptionsComponent } from "./newsletter/newsletter-options/newsletter-options.component";

@NgModule({
  declarations: [
    PrimaryButtonComponent,
    SliderComponent,
    TrackListComponent,
    TrackItemComponent,
    ArangersListComponent,
    HttpAlertComponent,
    LoaderComponent,
    AuthorizationComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    InvoiceDetailsListComponent,
    InvoiceDetailsComponent,
    UserDetailsFormComponent,
    ArrangerDetailsFormComponent,
    ArrangerCommissionFormComponent,
    AddNotesComponent,
    NoteListComponent,
    CategoryComponent,
    CartHandleComponent,
    CartComponent,
    CurrencyFormaterPipe,
    OrderTotalPipe,
    PaymentTypeComponent,
    ImageCropperComponent,
    NoteLevelComponent,
    SafeHtml,
    PrepaidByCodeComponent,
    PrepaidByCodeComponent,
    PrepaidTotalComponent,
    OrdersManagementComponent,
    ContractFormComponent,
    ContractsComponent,
    ContractAttachmentsComponent,
    ZaiksComponent,
    RateNoteComponent,
    ProfitsComponent,
    SuccessComponent,
    PrepaidManagementComponent,
    CookiesComponent,
    ArrangerContractDateFormComponent,
    AudioPlayerComponent,
    InvoiceListComponent,
    SongSuggestionComponent,
    NewsletterOptionsComponent,
  ],
  providers: [
    MessageService,
    HttpAlertService,
    CurrencyPipe,
    CurrencyFormaterPipe,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PrimeModule,
    RouterModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    ImageCropperModule,
    NgxImageZoomModule,
    CurrencyMaskModule,
    DndModule,
    RecaptchaModule,
  ],
  exports: [
    CommonModule,
    PrimaryButtonComponent,
    SliderComponent,
    TrackListComponent,
    TrackItemComponent,
    ArangersListComponent,
    HttpAlertComponent,
    PrimeModule,
    MaterialModule,
    LoaderComponent,
    RouterModule,
    TranslateModule,
    RegisterComponent,
    AuthorizationComponent,
    FormsModule,
    ReactiveFormsModule,
    ForgotPasswordComponent,
    InvoiceDetailsListComponent,
    InvoiceDetailsComponent,
    UserDetailsFormComponent,
    ArrangerDetailsFormComponent,
    ArrangerCommissionFormComponent,
    AddNotesComponent,
    NoteListComponent,
    InfiniteScrollModule,
    CategoryComponent,
    CartHandleComponent,
    CartComponent,
    PaymentTypeComponent,
    CurrencyFormaterPipe,
    OrderTotalPipe,
    ImageCropperComponent,
    ImageCropperModule,
    NoteLevelComponent,
    SafeHtml,
    NgxImageZoomModule,
    CurrencyMaskModule,
    PrepaidByCodeComponent,
    PrepaidTotalComponent,
    OrdersManagementComponent,
    DndModule,
    ContractFormComponent,
    ContractsComponent,
    ContractAttachmentsComponent,
    ZaiksComponent,
    RateNoteComponent,
    ProfitsComponent,
    SuccessComponent,
    PrepaidManagementComponent,
    CookiesComponent,
    ArrangerContractDateFormComponent,
    AudioPlayerComponent,
    InvoiceListComponent,
    SongSuggestionComponent,
    RecaptchaModule,
    NewsletterOptionsComponent,
  ],
})
export class SharedModule {}
